var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 157,
    viewBox: "0 0 154 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_764_9500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6582 98.6187V101.969C80.6582 107.281 78.6187 112.376 74.9884 116.133C71.358 119.89 66.4342 122 61.3001 122H49.3581C44.2241 122 39.3003 119.89 35.6699 116.133C32.0396 112.376 30 107.281 30 101.969V98.6187H80.6582Z",
    fill: "url(#paint0_linear_764_9500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.642 25H48.5704C43.6665 25 38.9634 27.0158 35.4958 30.604C32.0282 34.1922 30.0801 39.0588 30.0801 44.1333V53.5618C36.6018 53.845 36.5884 64.3027 30.0801 64.6136V64.9106C31.1607 64.8919 32.2167 65.2454 33.0819 65.9156C33.9471 66.5858 34.5725 67.5347 34.8595 68.6129H104.642C109.776 68.6129 114.7 66.5025 118.33 62.7459C121.961 58.9893 124 53.8943 124 48.5816V44.9967C123.991 39.6901 121.948 34.6039 118.319 30.8548C114.689 27.1057 109.77 25 104.642 25Z",
    fill: "url(#paint1_linear_764_9500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7018 53.5755H30.3604C36.6018 54.1419 36.495 64.3026 30.0801 64.5858V64.8828C36.802 65.014 36.7553 75.7895 30.0801 75.9345V76.2315C36.802 76.3628 36.7553 87.1382 30.0801 87.2833V87.5734C36.802 87.7046 36.7553 98.4801 30.0801 98.6251V98.6458H88.7018C93.8358 98.6458 98.7597 96.5354 102.39 92.7788C106.02 89.0222 108.06 83.9272 108.06 78.6146V73.5722C108.051 68.2656 106.008 63.1794 102.378 59.4303C98.7488 55.6812 93.8301 53.5755 88.7018 53.5755Z",
    fill: "url(#paint2_linear_764_9500)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.642 25H48.5704C43.6665 25 38.9634 27.0158 35.4958 30.604C32.0282 34.1922 30.0801 39.0588 30.0801 44.1333V53.5618C36.6018 53.845 36.5884 64.3027 30.0801 64.6136V64.9106C31.1607 64.8919 32.2167 65.2454 33.0819 65.9156C33.9471 66.5858 34.5725 67.5347 34.8595 68.6129H104.642C109.776 68.6129 114.7 66.5025 118.33 62.7459C121.961 58.9893 124 53.8943 124 48.5816V44.9967C123.991 39.6901 121.948 34.6039 118.319 30.8548C114.689 27.1057 109.77 25 104.642 25Z",
    fill: "url(#paint3_linear_764_9500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_9500",
    x: 0,
    y: 0,
    width: 154,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_9500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_9500",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_764_9500",
    x1: 55.3792,
    y1: 88.9138,
    x2: 55.3792,
    y2: 465.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#62BF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#62BF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_764_9500",
    x1: -8.93651,
    y1: 46.7926,
    x2: 1505.17,
    y2: 46.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#62BF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#62BF7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_764_9500",
    x1: -2.3147,
    y1: 76.1003,
    x2: 1254.76,
    y2: 76.1003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#457DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7B4FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_764_9500",
    x1: -8.93651,
    y1: 46.7926,
    x2: 1505.17,
    y2: 46.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#62BF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#62BF7A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1787b5ddb33206eb80135b1ee8eb4f53.svg";
export { ForwardRef as ReactComponent };